var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formData
    ? _c(
        "div",
        {
          staticClass: "fin-form solid-table",
          class: _vm.theme === "dark" ? "dark" : "shine"
        },
        [
          !_vm.backend
            ? _c("div", { staticClass: "fin-form-header" }, [
                _vm._v(" " + _vm._s(_vm.nameLabel || "--") + " ")
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "fin-form-content" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    size: "mini",
                    inline: true,
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-suffix": "："
                  }
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.collapseModel,
                        callback: function($$v) {
                          _vm.collapseModel = $$v
                        },
                        expression: "collapseModel"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "基础信息", name: "type" } },
                        [
                          !_vm.backend
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "name",
                                  attrs: { label: "方案名称", prop: "name" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入方案名称",
                                      rules: _vm.rules.name,
                                      maxlength: 30
                                    },
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "name", $$v)
                                      },
                                      expression: "formData.name"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              ref: "landOrSea",
                              attrs: { label: "风场类型", prop: "landOrSea" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { value: _vm.formData.landOrSea },
                                  on: { change: _vm.changeLandOrSea }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "陆地风场", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "海上风场", value: 2 }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "10px" } },
                                [_vm._v("切换模板后表单会被重新填充")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "关键指标", name: "important" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              ref: "operatingPeriod",
                              attrs: {
                                label: "运营期（年）",
                                prop: "operatingPeriod",
                                rules: _vm.rules.operatingPeriod
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.operatingPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "operatingPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "formData.operatingPeriod"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "constructionPeriod",
                              attrs: {
                                label: "建设期（年）",
                                prop: "constructionPeriod",
                                rules: _vm.rules.constructionPeriod
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.constructionPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "constructionPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "formData.constructionPeriod"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "cap",
                              attrs: { label: "装机容量（MW）", prop: "cap" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.cap,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "cap", $$v)
                                  },
                                  expression: "formData.cap"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "staticTotalInvestment",
                              attrs: {
                                label: "静态总投资（万元）",
                                prop: "staticTotalInvestment"
                              }
                            },
                            [
                              _c("total-invest", {
                                key: _vm.formData.economicId,
                                attrs: {
                                  cap: +_vm.formData.cap,
                                  base: _vm.baseValue,
                                  backend: _vm.backend
                                },
                                on: {
                                  click: function($event) {
                                    _vm.totalInvestVisible = true
                                  }
                                },
                                model: {
                                  value: _vm.formData.staticTotalInvestment,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "staticTotalInvestment",
                                      $$v
                                    )
                                  },
                                  expression: "formData.staticTotalInvestment"
                                }
                              }),
                              !_vm.backend
                                ? _c("total-invest-dialog", {
                                    attrs: {
                                      visible: _vm.totalInvestVisible,
                                      planId: _vm.formData.planId,
                                      economicId: _vm.formData.economicId,
                                      formData: _vm.formData
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.totalInvestVisible = $event
                                      },
                                      changeInvestDetail:
                                        _vm.changeInvestDetail,
                                      changeStaticTotalInvestment:
                                        _vm.changeStaticTotalInvestment
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "capitalRate",
                              attrs: {
                                label: "资本金比例（%）",
                                prop: "capitalRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.capitalRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "capitalRate", $$v)
                                  },
                                  expression: "formData.capitalRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "loanInterestRate",
                              attrs: {
                                label: "长期贷款利率（%）",
                                prop: "loanInterestRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.loanInterestRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "loanInterestRate",
                                      $$v
                                    )
                                  },
                                  expression: "formData.loanInterestRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "equivalentHour",
                              attrs: {
                                label: "满发小时数（h）",
                                prop: "equivalentHour"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.equivalentHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "equivalentHour",
                                      $$v
                                    )
                                  },
                                  expression: "formData.equivalentHour"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "priceWith",
                              attrs: {
                                label: "含税电价（元/kwh）",
                                prop: "priceWith"
                              }
                            },
                            [
                              _c("e-price", {
                                model: {
                                  value: _vm.formData.priceWith,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "priceWith", $$v)
                                  },
                                  expression: "formData.priceWith"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "基本参数", name: "basic" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("年限和装机容量")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "operatingPeriod",
                              attrs: {
                                label: "运营期（年）",
                                prop: "operatingPeriod"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.operatingPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "operatingPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "formData.operatingPeriod"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "constructionPeriod",
                              attrs: {
                                label: "建设期（年）",
                                prop: "constructionPeriod"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.constructionPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "constructionPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "formData.constructionPeriod"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "constructionStarttime",
                              attrs: {
                                label: "开工年份",
                                prop: "constructionStarttime"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  type: "year",
                                  placeholder: "请输入开工年份",
                                  "picker-options": _vm.pickerOptions
                                },
                                model: {
                                  value: _vm.formData.constructionStarttime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "constructionStarttime",
                                      $$v
                                    )
                                  },
                                  expression: "formData.constructionStarttime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "装机容量（MW）", prop: "cap" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.cap,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "cap", $$v)
                                  },
                                  expression: "formData.cap"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("建设期分年度投资")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "静态总投资（万元）",
                                prop: "staticTotalInvestment"
                              }
                            },
                            [
                              _c("total-invest", {
                                key: _vm.formData.economicId,
                                attrs: {
                                  cap: +_vm.formData.cap,
                                  base: _vm.baseValue,
                                  backend: _vm.backend
                                },
                                on: {
                                  click: function($event) {
                                    _vm.totalInvestVisible = true
                                  }
                                },
                                model: {
                                  value: _vm.formData.staticTotalInvestment,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "staticTotalInvestment",
                                      $$v
                                    )
                                  },
                                  expression: "formData.staticTotalInvestment"
                                }
                              })
                            ],
                            1
                          ),
                          _c("cap-year-input", {
                            ref: "constructionInvestArr",
                            attrs: {
                              label: "分年度投资（万元）",
                              prop: "constructionInvestArr",
                              base: 1,
                              cap: +_vm.formData.staticTotalInvestment,
                              count: _vm.constructionPeriodCount,
                              rules: _vm.rules.constructionInvest
                            },
                            model: {
                              value: _vm.formData.constructionInvestArr,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "constructionInvestArr",
                                  $$v
                                )
                              },
                              expression: "formData.constructionInvestArr"
                            }
                          }),
                          _c(
                            "el-form-item",
                            {
                              ref: "vatRate",
                              attrs: {
                                label: "可抵扣增值税比例（%）",
                                prop: "vatRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.vatRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "vatRate", $$v)
                                  },
                                  expression: "formData.vatRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c("multi-input", {
                            ref: "immaterialAssetsArr",
                            attrs: {
                              prop: "immaterialAssetsArr",
                              rules: _vm.rules.immaterialAssets,
                              label: "无形资产（万元）",
                              defaultValue: "0",
                              count: _vm.constructionPeriodCount
                            },
                            model: {
                              value: _vm.formData.immaterialAssetsArr,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "immaterialAssetsArr",
                                  $$v
                                )
                              },
                              expression: "formData.immaterialAssetsArr"
                            }
                          }),
                          _c("multi-input", {
                            ref: "otherAssetsArr",
                            attrs: {
                              prop: "otherAssetsArr",
                              rules: _vm.rules.otherAssets,
                              label: "其他资产（万元）",
                              defaultValue: "0",
                              count: _vm.constructionPeriodCount
                            },
                            model: {
                              value: _vm.formData.otherAssetsArr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "otherAssetsArr", $$v)
                              },
                              expression: "formData.otherAssetsArr"
                            }
                          }),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("资本金投入")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "capitalRate",
                              attrs: {
                                label: "资本金比例（%）",
                                prop: "capitalRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.capitalRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "capitalRate", $$v)
                                  },
                                  expression: "formData.capitalRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "marr",
                              attrs: {
                                label: "资本金基准收益率-贴现率（%）",
                                prop: "marr"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.marr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "marr", $$v)
                                  },
                                  expression: "formData.marr"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "marrBeforeTax",
                              attrs: {
                                label: "行业基准收益率（所得税前）（%）",
                                prop: "marrBeforeTax"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.marrBeforeTax,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "marrBeforeTax", $$v)
                                  },
                                  expression: "formData.marrBeforeTax"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "marrAfterTax",
                              attrs: {
                                label: "行业基准收益率（所得税后）（%）",
                                prop: "marrAfterTax"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.marrAfterTax,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "marrAfterTax", $$v)
                                  },
                                  expression: "formData.marrAfterTax"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("流动资金及短期贷款")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "fluidUnit",
                              attrs: {
                                label: "单位千瓦流动资金（元/kw）",
                                prop: "fluidUnit"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.fluidUnit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "fluidUnit", $$v)
                                  },
                                  expression: "formData.fluidUnit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "fluidLoanRatio",
                              attrs: {
                                label: "流动资金贷款比例（%）",
                                prop: "fluidLoanRatio"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.fluidLoanRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "fluidLoanRatio",
                                      $$v
                                    )
                                  },
                                  expression: "formData.fluidLoanRatio"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "fluidLoanRate",
                              attrs: {
                                label: "流动资金贷款利率（%）",
                                prop: "fluidLoanRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.fluidLoanRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "fluidLoanRate", $$v)
                                  },
                                  expression: "formData.fluidLoanRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "shortLoanRate",
                              attrs: {
                                label: "短期贷款利率（%）",
                                prop: "shortLoanRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.shortLoanRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "shortLoanRate", $$v)
                                  },
                                  expression: "formData.shortLoanRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("长期借款利息")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "repaymentPeriod",
                              attrs: {
                                label: "贷款年限（年）",
                                prop: "repaymentPeriod"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.repaymentPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "repaymentPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "formData.repaymentPeriod"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "repayType",
                              attrs: {
                                label: "还款类型（%）",
                                prop: "repayType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择还款类型" },
                                  model: {
                                    value: _vm.formData.repayType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "repayType", $$v)
                                    },
                                    expression: "formData.repayType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "等额本息", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "等额本金", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "loanInterestRate",
                              attrs: {
                                label: "长期贷款利率（%）",
                                prop: "loanInterestRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.loanInterestRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "loanInterestRate",
                                      $$v
                                    )
                                  },
                                  expression: "formData.loanInterestRate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "成本费用", name: "cost" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("折旧费")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "salvage",
                              attrs: { label: "残值率（%）", prop: "salvage" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.salvage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "salvage", $$v)
                                  },
                                  expression: "formData.salvage"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "depreciableType",
                              attrs: {
                                label: "折旧数据类型",
                                prop: "depreciableType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择折旧数据类型",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.depreciableType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "depreciableType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.depreciableType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "折旧年限", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "综合折旧率", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "手动输入折旧费", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.depreciableType !== 2
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "depreciableData",
                                  attrs: {
                                    prop: "depreciableData",
                                    label: [
                                      "折旧年限（年）",
                                      "综合折旧率（%）",
                                      "折旧费（万元）"
                                    ][_vm.formData.depreciableType]
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.depreciableData,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "depreciableData",
                                          $$v
                                        )
                                      },
                                      expression: "formData.depreciableData"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.depreciableType === 2
                            ? _c("multi-input", {
                                ref: "depreciableDataArr",
                                attrs: {
                                  prop: "depreciableDataArr",
                                  rules: _vm.rules.depreciableData,
                                  label: [
                                    "折旧年限（年）",
                                    "综合折旧率（%）",
                                    "折旧费（万元）"
                                  ][_vm.formData.depreciableType],
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.depreciableDataArr,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "depreciableDataArr",
                                      $$v
                                    )
                                  },
                                  expression: "formData.depreciableDataArr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("维修费")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "maintainType",
                              attrs: {
                                label: "维修数据单位",
                                prop: "maintainType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择维修数据单位",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.maintainType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "maintainType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.maintainType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "%", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "元/kw", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "万元", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "maintainNum",
                              attrs: { label: "数据维数", prop: "maintainNum" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择数据维数",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.maintainNum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "maintainNum", $$v)
                                    },
                                    expression: "formData.maintainNum"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "各年相同", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "各年不同", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.maintainNum === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "maintainData",
                                  attrs: {
                                    prop: "maintainData",
                                    label: `${
                                      ["维修费率", "单位维修费", "维修费"][
                                        _vm.formData.maintainType
                                      ]
                                    }`
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.maintainData,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "maintainData",
                                          $$v
                                        )
                                      },
                                      expression: "formData.maintainData"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.maintainNum === 1
                            ? _c("multi-input", {
                                ref: "maintainDataArr",
                                attrs: {
                                  prop: "maintainDataArr",
                                  rules: _vm.rules.maintainData,
                                  label: `${
                                    ["维修费率", "单位维修费", "维修费"][
                                      _vm.formData.maintainType
                                    ]
                                  }`,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.maintainDataArr,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "maintainDataArr",
                                      $$v
                                    )
                                  },
                                  expression: "formData.maintainDataArr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("人工工资及福利")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "staffTypeNum",
                              attrs: {
                                label: "人员种类",
                                prop: "staffTypeNum",
                                rules: _vm.rules.staffTypeNum
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.staffTypeNum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "staffTypeNum", $$v)
                                  },
                                  expression: "formData.staffTypeNum"
                                }
                              })
                            ],
                            1
                          ),
                          _c("multi-input", {
                            ref: "staffCapacityArr",
                            attrs: {
                              prop: "staffCapacityArr",
                              rules: _vm.rules.staffCapacity,
                              label: "人员数量",
                              unit: "种",
                              count: _vm.staffTypeNumCount
                            },
                            model: {
                              value: _vm.formData.staffCapacityArr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "staffCapacityArr", $$v)
                              },
                              expression: "formData.staffCapacityArr"
                            }
                          }),
                          _c("multi-input", {
                            ref: "staffSalaryArr",
                            attrs: {
                              prop: "staffSalaryArr",
                              rules: _vm.rules.staffSalary,
                              label: "人均年平均工资（万元/年）",
                              unit: "种",
                              count: _vm.staffTypeNumCount
                            },
                            model: {
                              value: _vm.formData.staffSalaryArr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "staffSalaryArr", $$v)
                              },
                              expression: "formData.staffSalaryArr"
                            }
                          }),
                          _c("multi-input", {
                            ref: "welfareRateArr",
                            attrs: {
                              prop: "welfareRateArr",
                              rules: _vm.rules.welfareRate,
                              label: "福利系数（%）",
                              unit: "种",
                              count: _vm.staffTypeNumCount
                            },
                            model: {
                              value: _vm.formData.welfareRateArr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "welfareRateArr", $$v)
                              },
                              expression: "formData.welfareRateArr"
                            }
                          }),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("保险费")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "insureType",
                              attrs: {
                                label: "保险数据单位",
                                prop: "insureType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择保险数据单位",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.insureType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "insureType", $$v)
                                    },
                                    expression: "formData.insureType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "%", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "元/kw", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "万元", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "insureNum",
                              attrs: {
                                label: "保险计算方式",
                                prop: "insureNum"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择保险计算方式",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.insureNum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "insureNum", $$v)
                                    },
                                    expression: "formData.insureNum"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "各年相同", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "各年不同", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "insureRaw",
                              attrs: {
                                label: "保险计算基数",
                                prop: "insureRaw"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择保险计算基数" },
                                  model: {
                                    value: _vm.formData.insureRaw,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "insureRaw", $$v)
                                    },
                                    expression: "formData.insureRaw"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "固定资产原值", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "固定资产净值", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.insureNum === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "insureData",
                                  attrs: {
                                    prop: "insureData",
                                    label: `${
                                      ["保险费率", "单位保险费", "保险费"][
                                        _vm.formData.insureType
                                      ]
                                    }`
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.insureData,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "insureData",
                                          $$v
                                        )
                                      },
                                      expression: "formData.insureData"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.insureNum === 1
                            ? _c("multi-input", {
                                ref: "insureDataArr",
                                attrs: {
                                  prop: "insureDataArr",
                                  rules: _vm.rules.insureData,
                                  label: `${
                                    ["保险费率", "单位保险费", "保险费"][
                                      _vm.formData.insureType
                                    ]
                                  }`,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.insureDataArr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "insureDataArr", $$v)
                                  },
                                  expression: "formData.insureDataArr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("材料费")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "materialType",
                              attrs: {
                                label: "材料费数据单位",
                                prop: "materialType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择材料费数据单位",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.materialType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "materialType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.materialType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "%", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "元/kw", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "万元", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "materialNum",
                              attrs: {
                                label: "材料费计算方式",
                                prop: "materialNum"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择材料费计算方式",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.materialNum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "materialNum", $$v)
                                    },
                                    expression: "formData.materialNum"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "各年相同", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "各年不同", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.materialNum === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "materialConsumption",
                                  attrs: {
                                    prop: "materialConsumption",
                                    label: `${
                                      ["材料费率", "单位材料费", "材料费"][
                                        _vm.formData.materialType
                                      ]
                                    }`
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.materialConsumption,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "materialConsumption",
                                          $$v
                                        )
                                      },
                                      expression: "formData.materialConsumption"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.materialNum === 1
                            ? _c("multi-input", {
                                ref: "materialConsumptionArr",
                                attrs: {
                                  prop: "materialConsumptionArr",
                                  rules: _vm.rules.materialConsumption,
                                  label: `${
                                    ["材料费率", "单位材料费", "材料费"][
                                      _vm.formData.materialType
                                    ]
                                  }`,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.materialConsumptionArr,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "materialConsumptionArr",
                                      $$v
                                    )
                                  },
                                  expression: "formData.materialConsumptionArr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("摊销费")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "immaterialAmortization",
                              attrs: {
                                label: "无形资产摊销年限（年）",
                                prop: "immaterialAmortization"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.immaterialAmortization,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "immaterialAmortization",
                                      $$v
                                    )
                                  },
                                  expression: "formData.immaterialAmortization"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "otherAmortization",
                              attrs: {
                                label: "其他资产摊销年限（年）",
                                prop: "otherAmortization"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.otherAmortization,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "otherAmortization",
                                      $$v
                                    )
                                  },
                                  expression: "formData.otherAmortization"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("其他费用")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "otherFeeNum",
                              attrs: {
                                label: "其他费用计算方式",
                                prop: "otherFeeNum"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.backend },
                                  model: {
                                    value: _vm.formData.otherFeeNum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "otherFeeNum", $$v)
                                    },
                                    expression: "formData.otherFeeNum"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "各年相同", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "各年不同", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "otherFeeType1",
                              attrs: {
                                label: "其他费用1单位",
                                prop: "otherFeeType1"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择单位",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.otherFeeType1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "otherFeeType1",
                                        $$v
                                      )
                                    },
                                    expression: "formData.otherFeeType1"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "元/kw", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "万元", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.otherFeeNum === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "otherFee1",
                                  attrs: {
                                    label: "其他费用1",
                                    prop: "otherFee1"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.otherFee1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "otherFee1", $$v)
                                      },
                                      expression: "formData.otherFee1"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.otherFeeNum === 1
                            ? _c("multi-input", {
                                ref: "otherFee1Arr",
                                attrs: {
                                  label: "其他费用1",
                                  prop: "otherFee1Arr",
                                  rules: _vm.rules.otherFee1,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.otherFee1Arr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "otherFee1Arr", $$v)
                                  },
                                  expression: "formData.otherFee1Arr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              ref: "otherFeeType2",
                              attrs: {
                                label: "其他费用2单位",
                                prop: "otherFeeType2"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择单位",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.otherFeeType2,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "otherFeeType2",
                                        $$v
                                      )
                                    },
                                    expression: "formData.otherFeeType2"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "元/kw", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "万元", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.otherFeeNum === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "otherFee2",
                                  attrs: {
                                    label: "其他费用2",
                                    prop: "otherFee2"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.otherFee2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "otherFee2", $$v)
                                      },
                                      expression: "formData.otherFee2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.otherFeeNum === 1
                            ? _c("multi-input", {
                                ref: "otherFee2Arr",
                                attrs: {
                                  label: "其他费用2",
                                  prop: "otherFee2Arr",
                                  rules: _vm.rules.otherFee2,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.otherFee2Arr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "otherFee2Arr", $$v)
                                  },
                                  expression: "formData.otherFee2Arr"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "收入和税金", name: "income" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("产量")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "equivalentHour",
                              attrs: {
                                label: "等效利用小时数（h）",
                                prop: "equivalentHour"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.equivalentHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "equivalentHour",
                                      $$v
                                    )
                                  },
                                  expression: "formData.equivalentHour"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "energyType",
                              attrs: {
                                label: "上网电量计算方式",
                                prop: "energyType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择上网电量计算方式",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.energyType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "energyType", $$v)
                                    },
                                    expression: "formData.energyType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "自动计算", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "手动输入", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("multi-input", {
                            ref: "energyData_Arr",
                            attrs: {
                              prop: "energyData_Arr",
                              defaultValue: 1,
                              rules: _vm.rules.energyData,
                              label: ["发电量系数", "电量数据（kWH）"][
                                _vm.formData.energyType
                              ],
                              count:
                                _vm.operatingPeriodCount +
                                _vm.constructionPeriodCount
                            },
                            model: {
                              value: _vm.formData.energyData_Arr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "energyData_Arr", $$v)
                              },
                              expression: "formData.energyData_Arr"
                            }
                          }),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("装机进度")]
                          ),
                          _c("cap-year-input", {
                            ref: "ongridCapacityArr",
                            attrs: {
                              prop: "ongridCapacityArr",
                              rules: _vm.rules.ongridCapacity,
                              label: "各年新增装机情况（MW）",
                              cap: +_vm.formData.cap,
                              count: _vm.constructionPeriodCount
                            },
                            model: {
                              value: _vm.formData.ongridCapacityArr,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "ongridCapacityArr", $$v)
                              },
                              expression: "formData.ongridCapacityArr"
                            }
                          }),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("税率")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "vat",
                              attrs: { label: "增值税率（%）", prop: "vat" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.vat,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "vat", $$v)
                                  },
                                  expression: "formData.vat"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "incomeTaxType",
                              attrs: {
                                label: "所得税计算方式",
                                prop: "incomeTaxType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择所得税计算方式",
                                    disabled: _vm.backend
                                  },
                                  model: {
                                    value: _vm.formData.incomeTaxType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "incomeTaxType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.incomeTaxType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "各年相同", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "各年不同", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.incomeTaxType === 0
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "incomeTaxRate",
                                  attrs: {
                                    label: "企业所得税率（%）",
                                    prop: "incomeTaxRate"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.incomeTaxRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "incomeTaxRate",
                                          $$v
                                        )
                                      },
                                      expression: "formData.incomeTaxRate"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.incomeTaxType === 1
                            ? _c("multi-input", {
                                ref: "incomeTaxRateArr",
                                attrs: {
                                  label: "企业所得税率（%）",
                                  prop: "incomeTaxRateArr",
                                  rules: _vm.rules.incomeTaxRate,
                                  count:
                                    _vm.operatingPeriodCount +
                                    _vm.constructionPeriodCount
                                },
                                model: {
                                  value: _vm.formData.incomeTaxRateArr,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "incomeTaxRateArr",
                                      $$v
                                    )
                                  },
                                  expression: "formData.incomeTaxRateArr"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              ref: "urbanConstructionTaxRate",
                              attrs: {
                                label: "城市维护建设费率（%）",
                                prop: "urbanConstructionTaxRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.urbanConstructionTaxRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "urbanConstructionTaxRate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.urbanConstructionTaxRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "educationAddRate",
                              attrs: {
                                label: "教育附加费（%）",
                                prop: "educationAddRate"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.educationAddRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "educationAddRate",
                                      $$v
                                    )
                                  },
                                  expression: "formData.educationAddRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "vatPolicy",
                              attrs: {
                                label: "增值税即征即退",
                                prop: "vatPolicy"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.formData.vatPolicy,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "vatPolicy", $$v)
                                    },
                                    expression: "formData.vatPolicy"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "无", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "有", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "incomeTaxNexempt",
                              attrs: {
                                label: "所得税N免（年）",
                                prop: "incomeTaxNexempt"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.incomeTaxNexempt,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "incomeTaxNexempt",
                                      $$v
                                    )
                                  },
                                  expression: "formData.incomeTaxNexempt"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "incomeTaxNhalved",
                              attrs: {
                                label: "所得税N减半（年）",
                                prop: "incomeTaxNhalved"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.incomeTaxNhalved,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "incomeTaxNhalved",
                                      $$v
                                    )
                                  },
                                  expression: "formData.incomeTaxNhalved"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "proportionSurplusReserve",
                              attrs: {
                                label: "法定盈余公积金比例（%）",
                                prop: "proportionSurplusReserve"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.proportionSurplusReserve,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "proportionSurplusReserve",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.proportionSurplusReserve"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "proportionSurplusDiscretionary",
                              attrs: {
                                label: "任意盈余公积金比例（%）",
                                prop: "proportionSurplusDiscretionary"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value:
                                    _vm.formData.proportionSurplusDiscretionary,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "proportionSurplusDiscretionary",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.proportionSurplusDiscretionary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "profitPayableRatio",
                              attrs: {
                                label: "应付利润比例（%）",
                                prop: "profitPayableRatio"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.profitPayableRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "profitPayableRatio",
                                      $$v
                                    )
                                  },
                                  expression: "formData.profitPayableRatio"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("电价")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "taxType",
                              attrs: { label: "税类型", prop: "taxType" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.formData.taxType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "taxType", $$v)
                                    },
                                    expression: "formData.taxType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "所得税", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "调整所得税", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "priceWith",
                              attrs: {
                                label: "含税电价（元/kwh）",
                                prop: "priceWith"
                              }
                            },
                            [
                              _c("e-price", {
                                model: {
                                  value: _vm.formData.priceWith,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "priceWith", $$v)
                                  },
                                  expression: "formData.priceWith"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "priceType",
                              attrs: {
                                label: "是否分两阶段电价",
                                prop: "priceType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.formData.priceType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "priceType", $$v)
                                    },
                                    expression: "formData.priceType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "否", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "是", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.priceType === 1
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "hoursLimit",
                                  attrs: {
                                    label: "第一阶段小时数（h）",
                                    prop: "hoursLimit"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.hoursLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "hoursLimit",
                                          $$v
                                        )
                                      },
                                      expression: "formData.hoursLimit"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.formData.priceType === 1
                            ? _c(
                                "el-form-item",
                                {
                                  ref: "priceWith2",
                                  attrs: {
                                    prop: "priceWith2",
                                    label: "第二阶段含税电价（元/kwh）"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.formData.priceWith2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "priceWith2",
                                          $$v
                                        )
                                      },
                                      expression: "formData.priceWith2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "计算LCOE", name: "lcoe" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              ref: "irrType",
                              attrs: { label: "IRR类型", prop: "irrType" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择还款类型" },
                                  model: {
                                    value: _vm.formData.irrType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "irrType", $$v)
                                    },
                                    expression: "formData.irrType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "项目投资税后收益率",
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "资本金收益率", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              ref: "irrData",
                              attrs: { label: "IRR大小", prop: "irrData" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.formData.irrData,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "irrData", $$v)
                                  },
                                  expression: "formData.irrData"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "敏感性分析", name: "sensitive" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              ref: "whetherSense",
                              attrs: {
                                label: "是否敏感性分析",
                                prop: "whetherSense"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.formData.whetherSense,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "whetherSense",
                                        $$v
                                      )
                                    },
                                    expression: "formData.whetherSense"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "否", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "是", value: 1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          +_vm.formData.whetherSense === 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "totalInvestArr_Arr",
                                      attrs: {
                                        label: "总投资浮动（%）",
                                        prop: "totalInvestArr_Arr"
                                      }
                                    },
                                    [
                                      _c("inputs", {
                                        attrs: {
                                          placeholder: "请输入",
                                          count: 5
                                        },
                                        model: {
                                          value:
                                            _vm.formData.totalInvestArr_Arr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "totalInvestArr_Arr",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.totalInvestArr_Arr"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "energyDataArr_Arr",
                                      attrs: {
                                        label: "电量浮动（%）",
                                        prop: "energyDataArr_Arr"
                                      }
                                    },
                                    [
                                      _c("inputs", {
                                        attrs: {
                                          placeholder: "请输入",
                                          count: 5
                                        },
                                        model: {
                                          value: _vm.formData.energyDataArr_Arr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "energyDataArr_Arr",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.energyDataArr_Arr"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "priceWithArr_Arr",
                                      attrs: {
                                        label: "含税电价浮动（%）",
                                        prop: "priceWithArr_Arr"
                                      }
                                    },
                                    [
                                      _c("inputs", {
                                        attrs: {
                                          placeholder: "请输入",
                                          count: 5
                                        },
                                        model: {
                                          value: _vm.formData.priceWithArr_Arr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "priceWithArr_Arr",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.priceWithArr_Arr"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      ref: "loanInterestRateArr_Arr",
                                      attrs: {
                                        label: "长期贷款利率浮动（%）",
                                        prop: "loanInterestRateArr_Arr"
                                      }
                                    },
                                    [
                                      _c("inputs", {
                                        attrs: {
                                          placeholder: "请输入",
                                          count: 5
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .loanInterestRateArr_Arr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "loanInterestRateArr_Arr",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.loanInterestRateArr_Arr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bottom-tool" },
            [
              _vm.canSave
                ? _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.reset } },
                    [_vm._v("重置")]
                  )
                : _vm._e(),
              _vm.canSave
                ? _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.save } },
                    [_vm._v(_vm._s(_vm.backend ? "保存" : "保存并计算"))]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _c("div", [
        _c("div", { staticClass: "fin-form empty-form" }, [_vm._v("暂无数据")])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }